
import { onMounted, ref } from 'vue'
import ConfigRepository from '@/services/ConfigRepository'
import Config from '@/models/config.models'
import { useToast } from 'primevue/usetoast'
import {useStore} from "vuex";
import {useRouter} from "vue-router";

export default {
  setup() {
    const content = ref('')
    const appConfig = ref({} as Config)
    const toast = useToast()
    const store = useStore()
    const router = useRouter()

    if(!(store.state.permission == 'mster')){
      router.push({
        name: 'home'
      });
    }

    const periods = ref([
      {display: '5 phút', value: 5},
      {display: '10 phút', value: 10},
      {display: '15 phút', value: 15},
      {display: '20 phút', value: 20},
      {display: '30 phút', value: 30},
      {display: '45 phút', value: 45},
      {display: '1 tiếng', value: 60},
      {display: '2 tiếng', value: 120},
    ])

    const loadConfig = () => {
      ConfigRepository.getConfig()
          .then((_) => {
            appConfig.value = {
              ... _.data,
              date_start_at: new Date(_.data.date_start_at),
              date_end_at: new Date(_.data.date_end_at),
              lunch_start: new Date(_.data.lunch_start),
              lunch_end: new Date(_.data.lunch_end),
            }
          })
    }

    const saveConfig = () => {
      ConfigRepository.saveConfig(appConfig.value)
          .then(() => {
            toast.add({
              severity: 'success',
              summary: 'Cấu hình',
              detail: 'Thông tin đã được lưu.',
              life: 1000,
            })
          })
          .catch(() => {
            toast.add({
              severity: 'error',
              summary: 'Cấu hình',
              detail: 'Lưu cấu hình thất bại.',
              life: 1000,
            })
          })
    }

    onMounted(loadConfig)

    return {
      content,
      appConfig,
      periods,
      saveConfig,
    }
  },
}
